import { ILogger } from '../concepts/logger';
import { StoreSlice } from '../../utils/store-slice';
import produce from 'immer';
import { IAvatar } from '../concepts/avatar';
import { IPlayer } from '../concepts/player';
import { remote } from '../../../remote';
import { IGame } from '../concepts/game';

export const create: StoreSlice<IAvatar, ILogger & IPlayer & IGame> = (
  set,
  get
) => {
  return {
    availableAvatars: new Array(12).fill(0).map((v, i) => `avatar-${i}`),
    avatars: {},

    setPlayerAvatar(playerId: string, avatar: string) {
      set(
        produce((s: IAvatar) => {
          s.avatars[playerId] = avatar;
        })
      );
    },

    selectAvatar(playerId: string, avatar: string) {
      if (get().hasSelectedAvatar(playerId)) {
        console.log('👤 [Avatar] selectAvatar skipped - already selected:', playerId);
        return;
      }

      console.log('👤 [Avatar] selectAvatar called:', { playerId, avatar, gameId: get().gameId });
      get().log(`avatar selected: player ${playerId}, avatar: ${avatar}`);
      get().setPlayerAvatar(playerId, avatar);

      remote.saveAvatar(get().gameId, playerId, avatar)
        .then(() => {
          console.log('✅ [Avatar] saveAvatar succeeded for player:', playerId);
        })
        .catch((error) => {
          console.error('❌ [Avatar] saveAvatar failed for player:', playerId, error);
        });
    },

    isAvatarSelected(playerId, avatar) {
      return get().avatars[playerId] === avatar;
    },

    hasSelectedAvatar(playerId: string) {
      return !!get().avatars[playerId];
    },

    hasNotSelectedAvatar(playerId: string) {
      return !get().hasSelectedAvatar(playerId);
    },

    areAllAvatarsSelected() {
      const players = get().players;
      const avatars = get().avatars;
      const allSelected = players.every(get().hasSelectedAvatar);

      console.log('👤 [Avatar] areAllAvatarsSelected check:', {
        players,
        avatars,
        allSelected,
        playersWithoutAvatar: players.filter(get().hasNotSelectedAvatar)
      });

      return allSelected;
    },

    playersWithoutAvatarCount() {
      return get().players.filter(get().hasNotSelectedAvatar).length;
    },
  };
};
